function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTooltipInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15.91 15.91"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 7.95,
  cy: 7.95,
  r: 7.95,
  style: {
    fill: "var(--tooltip-info-icon-bg, #686d71)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 5.18a1.24 1.24 0 1 1 1.19-1.24A1.24 1.24 0 0 1 8 5.18m-1.06 8V6H9v7.2z",
  style: {
    fill: "var(--tooltip-info-icon-color, #fff)"
  }
}));
export default SvgTooltipInfo;